import { useMediaQuery } from '@mantine/hooks'

// Mantine lg breakpoint = 75em (1200px). Below that the hero needs more
// negative pull to account for the smaller header height on laptops/tablets.
export const useHeroMargin = () => {
  const isDesktop = useMediaQuery('(min-width: 75em)', false, {
    getInitialValueInEffect: false
  })

  return isDesktop
    ? 'calc(var(--mantine-spacing-lg) * -2)'
    : 'calc(var(--mantine-spacing-lg) * -4)'
}
